/**
 * Formate la fecha resultante de un Date a formato dd/mm/YYYY
 * @param value
 * @returns {Promise<string>}
 */
export const dateToFormatUi = async (value) => {
    let d = new Date(value),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();
    if (month.length < 2)
        month = '0' + month;
    if (day.length < 2)
        day = '0' + day;
    return [day, month, year].join('/');
}

/**
 * Formate la fecha resultante de un Date a formato YYYY-mm-dd
 * @param value
 * @returns {string}
 */
export const dateToFormatDateServer = async (value) => {
    let d = new Date(value),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();
    if (month.length < 2)
        month = '0' + month;
    if (day.length < 2)
        day = '0' + day;
    return [year, month, day].join('-');
}

/**
 * Retornar un objeto como un query string
 * @param objectData
 * @returns {string}
 */
export const queryObjectToString = (objectData) => {
    // Obtener los keys
    let keys = Object.keys(objectData);
    // Obtener la ultima clave del array
    let lastKey = keys[keys.length - 1]
    // Acumulador o texto que se formara dinamicamente.
    let queryString = "";
    for (let namaKey of keys) {
        queryString += `${namaKey}=${objectData[namaKey]}`
        if (namaKey !== lastKey) {
            queryString += '&'
        }
    }
    return queryString
}

/**
 * Normaliza la URL del creativo para servirlo desde CloudFront.
 * - Si la URL empieza con el prefix legacy de S3, lo reemplaza por el de CloudFront.
 * - En cualquier otro caso, devuelve la URL tal cual.
 */
export const normalizeCreativeUrl = (url) => {
    if (typeof url !== 'string') return url;
    const trimmed = url.trim();
    if (!trimmed) return url;

    const legacyPrefix = 'https://by-scaling-clic-spy-anuncios.s3.us-east-2.amazonaws.com/';
    const cdnPrefix = 'https://d1y59uwrqmncmn.cloudfront.net/';

    return trimmed.startsWith(legacyPrefix)
        ? `${cdnPrefix}${trimmed.slice(legacyPrefix.length)}`
        : url;
}